import React from 'react';

import Media from "./player/media";
import Scrubber from "./player/scrubber";
import Togglable from "./togglable";

//import TypeIcon from "./metadata/typeicon";

const PreviousLink = Togglable(({ title, href, thumbnail, type, onImage404 }) => (
	<a className="carousel-control-prev" href={href} role="button" title={title}>
		<span aria-hidden="true" className="carousel-control-prev-icon"></span>
		<span className="sr-only">Previous</span>
	</a>
))

const NextLink = Togglable(({ title, href, thumbnail, type, onImage404 }) => (
	<a className="carousel-control-next" href={href} role="button" title={title}>
		<span aria-hidden="true" className="carousel-control-next-icon"></span>
		<span className="sr-only">Next</span>
	</a>
))

const ScrubberLink = Togglable(({ show_scrubber, showScrubber }) => (
	<button aria-controls="collapse-gui-timeline" aria-expanded="true" className="carousel-control-prev gui-timeline-toggle unsw-mw-0" type="button" onClick={()=>showScrubber(!show_scrubber)}>
		<i aria-hidden="true" className="material-icons">comment</i>
		<span className="sr-only">Toggle timeline</span>
	</button>
))

const MediaNav = Togglable(({ allow_chart, previous, next, show_scrubber, showScrubber, removeRelatedThumbnail }) => (
	<div className="gui-player-nav">
		<ScrubberLink visible={allow_chart} show_scrubber={show_scrubber} showScrubber={showScrubber} />
		<PreviousLink visible={previous!==null} direction="previous" {...previous} onImage404={removeRelatedThumbnail.bind(null, "previous")} />
		<NextLink visible={next!==null} direction="next" {...next} onImage404={removeRelatedThumbnail.bind(null, "next")} />
	</div>
))

const Player = Togglable(({ comments, show_scrubber, iframe, duration, position, next, previous, show_media, allow_chart, showScrubber, setPlayerLoaded, goToComment, seek, removeRelatedThumbnail }) => (
	<div className={"carousel bg-dark-2 mb-3 mb-lg-4"+(iframe?" px-lg-5 gui-player-container":"")} style={allow_chart&&!iframe?{"padding-bottom": "5.5rem"}:{}}>
		<Media visible={show_media} iframe={iframe} setPlayerLoaded={setPlayerLoaded} />
		<MediaNav visible={show_media && iframe} allow_chart={allow_chart} previous={previous} next={next} show_scrubber={show_scrubber} showScrubber={showScrubber} removeRelatedThumbnail={removeRelatedThumbnail} />
		<Scrubber
			visible={allow_chart && show_scrubber}
			iframe={iframe}
			comments={comments}
			duration={duration}
			position={position}
			showScrubber={showScrubber}
			goToComment={goToComment}
			seek={seek}
		/>
	</div>
))

export default Player;